import { Fragment, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import Image from 'next/image'
import { IconContext } from 'react-icons'
import {
  BsArrowRight,
  BsBookmark,
  BsBookmarkFill,
  BsFacebook,
  BsYoutube,
  BsInstagram,
  BsApple,
  BsSpotify,
  BsLinkedin,
} from 'react-icons/bs'
import { FaTiktok } from 'react-icons/fa'
import { BsGlobe2 } from 'react-icons/bs'
import { RiCloseFill } from 'react-icons/ri'
import Button from '@/components/common/Button'
import { getScreenWidth } from '@/utils/clientEnv'
import { Popover, Transition } from '@headlessui/react'
import SpeechTitlesModal from '@/components/speaker/SpeechTitlesModal'
import SpeechTitles from '@/components/speaker/SpeechTitles'
import SocialLinks from '@/components/speaker/SocialLinks'
import Markdown from '@/components/common/Markdown'
import { SPEECH_TITLES_DISPLAY_LIMIT } from '@/utils/CarouselConfigConstants'
import styles from '@/styles/components/speaker.module.scss'
import { useIsClamped } from '@/hooks/useIsClamped'

const SpeakerDetails = ({
  speaker,
  isSpeakersEnabled,
  isSpeakerBookmarked,
  setSpeakerBookmarked,
  handleDeleteBookmark,
  handleAddBookmark,
  handleRequestBooking,
  setSpeechTitlesOpen,
  loggedInUserDetails,
}) => {
  const speakerCategories = []
  const speakerSocialIcons = []
  const speakerProfiles = []
  const speakerProfileLinks = []
  const speechTopics = { headings: [], descriptions: [], speechTitles: [] }

  const shortDescription = speaker?.short_description ? speaker?.short_description : ''
  const longDescription = speaker?.long_description ? speaker?.long_description : ''
  const speakerDescription = longDescription ? shortDescription + longDescription : shortDescription
  const [readMoreBtnRender, setReadMoreBtnRender] = useState(false)
  const ref = useRef(null)
  const isClamped = useIsClamped(ref)

  useEffect(() => {
    const readMoreBtn =
      document.getElementById('headlessui-popover-button-:r16:') ||
      document.getElementById('headlessui-popover-button-:rc:')
    if (readMoreBtn) {
      readMoreBtn.removeAttribute('aria-expanded')
      setReadMoreBtnRender(false)
    }
  }, [readMoreBtnRender])
  const defaultImageUrl =
    'https://images.ctfassets.net/p6iqoqavudao/3lLPw0ct3NWRdllJaozgZr/238aa02d0b3a99038d1969146d7916f1/placeholder.png?q=100'

  speaker?.speakersTopics?.map((topic, i) => {
    speakerCategories[i] = { id: topic.id, name: topic?.name }
  })

  speaker?.speechTopics?.map((item, i) => {
    speechTopics.headings[i] = item.title.split(':')[0].trim()
    speechTopics.descriptions[i] = { title: item.title.split(':')[1], url: item.url }
    i <= SPEECH_TITLES_DISPLAY_LIMIT &&
      (speechTopics.speechTitles[i] = { title: item.title.trim(), url: item.url })
  })

  if (speaker && speaker?.socials) {
    Object.keys(speaker?.socials).map((profile, i) => {
      if (profile == 'twitter1') {
        speakerSocialIcons[i] = (
          <Image
            src="/static/icons/twitter.svg"
            className="opacity-70 hover:opacity-100"
            height={getScreenWidth() < 480 ? 27 : 20}
            width={getScreenWidth() < 480 ? 27 : 20}
            alt="X"
          />
        )
        speakerProfiles[i] = 'X'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
      if (profile == 'facebook1') {
        speakerSocialIcons[i] = <BsFacebook key="facebook" />
        speakerProfiles[i] = 'Facebook'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
      if (profile == 'youtube1') {
        speakerSocialIcons[i] = <BsYoutube key="youtube" />
        speakerProfiles[i] = 'Youtube'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
      if (profile == 'instagram1') {
        speakerSocialIcons[i] = <BsInstagram key="instagram" />
        speakerProfiles[i] = 'Instagram'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
      if (profile == 'tiktok1') {
        speakerSocialIcons[i] = <FaTiktok key="tiktok" />
        speakerProfiles[i] = 'Tiktok'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
      if (profile == 'spotify1') {
        speakerSocialIcons[i] = <BsSpotify key="spotify" />
        speakerProfiles[i] = 'Spotify'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
      if (profile == 'applemusic1') {
        speakerSocialIcons[i] = <BsApple key="applemusic1" />
        speakerProfiles[i] = 'Apple Music'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }

      if (profile == 'linkedinNaN') {
        speakerSocialIcons[i] = <BsLinkedin key="linkedinNaN" />
        speakerProfiles[i] = 'LinkedIn'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
      if (profile == 'artistWebsite' || profile == 'website') {
        speakerSocialIcons[i] = <BsGlobe2 key="artistWebsite" />
        speakerProfiles[i] = 'Website'
        if (speaker?.socials[profile]) {
          speakerProfileLinks[i] = speaker?.socials[profile]
        }
      }
    })
  }

  const speakerSocialLinkIcons = speakerProfiles.reduce((acc, value, ind) => {
    const newObj = {
      iconLable: value,
      icon: speakerSocialIcons[ind],
      link: speakerProfileLinks[ind],
    }
    acc.push(newObj)
    return acc
  }, [])

  return (
    <div className="lg:flex">
      <div className="profile-section sm:flex ">
        <div className="profile-img sm:mr-6">
          <div
            className={classNames(
              styles.profileImg,
              'w-full mb-5 xs:mb-0 h-[570px] md:h-96 lg:h-[570px] relative grid grid-cols-1 grid-rows-12  overflow-hidden'
            )}
          >
            <a>
              {speaker?.assets?.fields?.file?.url !== undefined ? (
                <>
                  <div class="flex animate-pulse items-center justify-center w-full relative h-96 lg:h-[570px] bg-gray-300 rounded-sm sm:w-96 dark:bg-gray-700">
                    <Image src="/static/icons/image-icon.svg" alt="" width={48} height={48} />
                  </div>
                  <Image
                    src={`https:${speaker?.assets?.fields?.file?.url}?f=top&q=100`}
                    alt=""
                    priority
                    fill
                    quality={100}
                    className="shadow-lg object-cover"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                </>
              ) : (
                <Image
                  src={defaultImageUrl}
                  alt=""
                  fill
                  quality={100}
                  className="object-cover"
                  sizes="100vw, 50vw, 33vw"
                />
              )}
            </a>
          </div>
        </div>
        <div className="flex flex-col justify-between">
          <div>
            <h1
              className="text-white text-5xl tagline-font uppercase leading-[52px]"
              data-cy="speakerName"
            >
              {speaker?.name}
            </h1>
            <div
              className="w-11/12 mt-4 mb-8 maxSm:mb-6 text-base font-normal text-white leading-2"
              data-cy="speakerSubtitle"
            >
              {speaker?.subline && <Markdown data={speaker?.subline} />}
            </div>
            {/* visible only in mobile  */}
            <div className="flex flex-wrap visible gap-4 mt-2 xs:invisible xs:absolute">
              {isSpeakersEnabled && (
                <Button
                  className="px-8 button-style button-hover group w-full"
                  label={'Bookmark'}
                  handleClick={() => {
                    loggedInUserDetails &&
                      (setSpeakerBookmarked(!isSpeakerBookmarked),
                      isSpeakerBookmarked
                        ? handleDeleteBookmark(speaker?.id)
                        : handleAddBookmark(speaker?.id))
                  }}
                  icon={
                    <IconContext.Provider
                      value={{
                        size: '1.2em',
                      }}
                    >
                      {isSpeakerBookmarked ? (
                        <BsBookmarkFill className="inline-block ml-4 text-white group-hover:text-black" />
                      ) : (
                        <BsBookmark className="inline-block ml-4 text-white group-hover:text-black" />
                      )}
                    </IconContext.Provider>
                  }
                ></Button>
              )}
              <Button
                className="px-8 button-style button-hover group w-full"
                label={'Booking Request'}
                icon={
                  <IconContext.Provider
                    value={{
                      size: '1.5em',
                    }}
                  >
                    <BsArrowRight className="inline-block ml-4 text-white group-hover:text-black" />
                  </IconContext.Provider>
                }
                handleClick={() => handleRequestBooking(speaker.slug)}
              ></Button>
            </div>
            <p className="visible uppercase tagline-font mt-7 xs:invisible xs:absolute">About</p>
            <div
              ref={ref}
              className={`text-base leading-6 w-11/12 line-clamp-[10] md:min-h-[15em]`}
              data-cy="speakerDescription"
            >
              {speakerDescription && (
                <Markdown data={speakerDescription} isHyperlink={true} isPadding={true} />
              )}
            </div>
            {speakerDescription && isClamped && (
              <div className="flex w-full pt-[18px] justify-left item-center">
                {speakerDescription?.length >= 500 && (
                  <>
                    <Popover className="relative h-5 bottom-0 hover:border-b">
                      <Popover.Button>
                        <BsArrowRight className="inline-block w-5 h-5 mr-3 text-white" />
                        <p className="inline-block text-sm">Read More</p>
                      </Popover.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-400"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel
                          role="dialog"
                          focus={true}
                          className="fixed inset-0 z-50 flex items-center justify-center w-full"
                        >
                          {({ close }) => (
                            <>
                              {
                                <SpeechTitlesModal
                                  name="readmore"
                                  header={
                                    <>
                                      <h1
                                        aria-label="speakerName"
                                        className={`${styles.readMore} mb-4 md:mb-14 w-11/12 text-3xl text-white uppercase bg-black tagline-font`}
                                      >
                                        About {speaker?.name}
                                      </h1>
                                      <div className="flex justify-end bg-black xl:pr-6 md:pr-1 "></div>
                                    </>
                                  }
                                  infoClassName={`w-[90%] text-sm leading-6`}
                                  info={
                                    <Markdown
                                      data={speakerDescription}
                                      isHyperlink={true}
                                      isPadding={true}
                                    />
                                  }
                                  footer={
                                    <>
                                      <button
                                        className="flex justify-center px-4 py-2 border w-36 mt-11 button-hover"
                                        onClick={() => {
                                          setReadMoreBtnRender(true)
                                          close()
                                        }}
                                      >
                                        <Button
                                          className="text-sm font-semibold"
                                          label="Close"
                                        ></Button>
                                      </button>
                                    </>
                                  }
                                  closeIcon={
                                    <>
                                      <button
                                        role="button"
                                        aria-label="close icon"
                                        className="absolute right-[0] bg-black text-white cursor-pointer"
                                        onClick={() => {
                                          setReadMoreBtnRender(true)
                                          close()
                                        }}
                                      >
                                        <RiCloseFill className="w-6 h-6" />
                                      </button>
                                    </>
                                  }
                                  outSideClick={() => {
                                    setReadMoreBtnRender(true)
                                    close()
                                  }}
                                />
                              }
                            </>
                          )}
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </>
                )}
              </div>
            )}
          </div>
          {/* visible in all screen except mobile  */}
          <div className="absolute flex invisible gap-6 md:flex-row maxSm:flex-col maxSm:mt-8 xs:visible xs:relative md:w-full">
            {isSpeakersEnabled && (
              <Button
                className="px-[6%] button-style profile-btn-res button-hover group"
                label={'Bookmark'}
                handleClick={() => {
                  loggedInUserDetails &&
                    (setSpeakerBookmarked(!isSpeakerBookmarked),
                    isSpeakerBookmarked
                      ? handleDeleteBookmark(speaker?.id)
                      : handleAddBookmark(speaker?.id))
                }}
                icon={
                  <IconContext.Provider
                    value={{
                      size: '1.2em',
                    }}
                  >
                    {isSpeakerBookmarked ? (
                      <BsBookmarkFill className="inline-block ml-4 text-white group-hover:text-black" />
                    ) : (
                      <BsBookmark className="inline-block ml-4 text-white group-hover:text-black" />
                    )}
                  </IconContext.Provider>
                }
              ></Button>
            )}
          </div>
        </div>
      </div>
      <div className="speach-social-section">
        {speaker?.speechTopics?.length > 0 && (
          <div className="speech-titles">
            <div>
              <SpeechTitles
                label="Speech Titles"
                speechTitles={speechTopics?.speechTitles ? speechTopics?.speechTitles : ['-']}
              />
            </div>
            <button
              className={`text-[11px] hover:border-b relative bottom-1 h-[18px] mt-5`}
              onClick={() => setSpeechTitlesOpen(true)}
            >
              <>
                <BsArrowRight className="inline-block w-5 h-5 mr-2 text-white" />
                <div className={`inline-block text-sm`}>View More</div>
              </>
            </button>
          </div>
        )}
        {speaker?.socials &&
          Object.keys(speaker?.socials).length !== 0 &&
          speakerProfileLinks.length !== 0 && (
            <div
              className={`socials-links ${
                speaker?.speechTopics ? 'lg:mt-2' : ''
              } maxLg:order-1 whitespace-nowrap`}
            >
              <SocialLinks
                speaker={speaker}
                label="Speaker Social Links"
                icons={speakerSocialLinkIcons}
                speakerProfileData={speaker?.socials}
              />
            </div>
          )}
      </div>
    </div>
  )
}

export default SpeakerDetails
